export default __webpack_public_path__ + "static/media/5.8c5d7506.jpg";